import { Network } from '../../../../utils/network'
import { Events } from '../../../../utils/servicesEvents'
import { Formatter } from '../../formatter'

import urls from '../urls.json'

async function launchSubscriptionPayment(data, onSuccessEvent, onErrorEvent) {
  const response = await sendRequest(data)
  const parsedResponse = parseResponse(response, Formatter)
  const onDoneEvent =
    parsedResponse.statusCode == 200 ? onSuccessEvent : onErrorEvent
  Events.dispatchEvent(onDoneEvent, parsedResponse)
}

async function sendRequest(data) {
  const url = urls.launchSubscriptionPayment

  const userData = await self.servicesVars.getUserData()
  const storeData = await self.servicesVars.getStoreData()

  const requestData = {
    firstName: userData.firstName,
    lastName: userData.lastName,
    paymentMethod: data.paymentMethod,
    storeId: storeData.id,
    storeName: storeData.storeName,
    userId: userData.reference,
    storeEmail: storeData.email || userData.email,
  }

  const response = await Network.sendPostRequest(url, requestData)
  return response
}

function parseResponse(response) {
  if (
    response &&
    response.status.code === 200 &&
    response.response?.statusCode == 200
  ) {
    return {
      statusCode: 200,
      message: 'Payment launched',
    }
  }
  if (response.status.code === 0) {
    return {
      success: false,
      message: 'error',
      networkError: true,
    }
  }
  return {
    success: false,
    message: 'error',
  }
}

export { launchSubscriptionPayment }
